import styled from "@emotion/styled";
import { DisplayText, ThemeText } from "components/lib";
import joinMember from "assets/joinMemberBg.png";
import freeToJoin from "assets/freeToJoin.png";
import annualJoinAsMember from "assets/annual_join_as_member_loyalty_bk.png";
import topupJoinAsMember from "assets/topup_join_as_member_loyalty_bk.png";

import { BonusZh, JoinBackground } from "./page-recharge";
import { JoinMemberMode } from "types/joinAsMemberMode";
import React from "react";
const getCount = (count: number) => {
  if (count === 0) {
    return 0;
  } else if (count < 10) {
    return count / 10;
  } else {
    return count % 10 === 0 ? count / 10 : count;
  }
};

export const PageBannerZh = (props: {
  count: number;
  backNum: number;
  restaurantName: string;
  hasPrePay: boolean;
  isVisible: Boolean;
  joinAsMemberMode: JoinMemberMode;
  afterLoad?: () => void;
}) => {
  // 整除时，只显示1位，不整除时，正常显示
  const currentShowCount = getCount(props.count);
  const hasCount = currentShowCount !== 10;
  const countLen = `${currentShowCount}`.length;
  const backNumLen = `${props.backNum}`.length;
  const imgStyleObj = {
    width: "29.5rem",
    height: "11.4rem",
    margin: "1.4rem auto 0 auto",
    display: "block",
    objectfit: "cover",
  };

  const handleOnCload = () => {
    if (props.afterLoad) {
      props.afterLoad();
    }
  };

  if (props.joinAsMemberMode !== JoinMemberMode.free_join) {

    return <Wrapper style={{ display: props.isVisible ? "block" : "none" }}>
      <RestaurantName>欢迎加入{props.restaurantName}会员</RestaurantName>
      <>
        <JoinBackground style={{ background: 'none', marginTop: '3.5rem' }}>
          <DisplayText>
            <img
              src={props.joinAsMemberMode === JoinMemberMode.annual_fee_join ? annualJoinAsMember : topupJoinAsMember}
              style={{ width: "29.5rem" }}
              onLoad={handleOnCload}
              loading="eager"
              alt="banner zh"
            ></img>
          </DisplayText>
        </JoinBackground>
      </>

    </Wrapper>;
  }

  if (!hasCount && !!!props.backNum && !!!props.hasPrePay) {
    // 无折扣无discount和无prapaid card
    return (
      <Wrapper style={{ display: props.isVisible ? "block" : "none" }}>
        {/* 顶部34，左右两边40，下 26 */}
        <RestaurantName>欢迎加入{props.restaurantName}会员</RestaurantName>
        {/* 顶部14 */}
        <>
          <JoinBackground>
            <DisplayText>
              <img
                src={freeToJoin}
                style={{ width: "28rem" }}
                onLoad={handleOnCload}
                loading="eager"
                alt="banner"
              ></img>
            </DisplayText>
          </JoinBackground>
        </>
        <BonusZh s={"3.3rem"} style={{ marginTop: "1rem" }}>
          {"更多权益敬请期待"}
        </BonusZh>
      </Wrapper>
    );
  } else {
    return (
      <Wrapper style={{ display: props.isVisible ? "block" : "none" }}>
        {/* 顶部34，左右两边40，下 26 */}
        <RestaurantName>欢迎加入{props.restaurantName}会员</RestaurantName>
        {/* 顶部14 */}
        {hasCount && !!props.backNum && (
          <div style={{ position: 'relative' }}>
            <img
              style={imgStyleObj}
              src={joinMember}
              onLoad={handleOnCload}
              loading="eager"
              alt="banner zh"
            />
            <BannerNumber len={countLen}>{currentShowCount}</BannerNumber>
            <RewardNum len={backNumLen}>{props.backNum}%</RewardNum>
          </div>
        )}
        {/* 无count */}
        {(!hasCount || !props.backNum) && (
          <>
            <JoinBackground>
              <DisplayText>
                <img
                  src={freeToJoin}
                  style={{ width: "28rem" }}
                  onLoad={handleOnCload}
                  loading="eager"
                  alt="banner"
                ></img>
              </DisplayText>
            </JoinBackground>
          </>
        )}
        {/* 仅有返现 */}
        {!hasCount && !!props.backNum && (
          <BonusZh
            s={backNumLen > 1 ? "3.8rem" : "4.2rem"}
            style={{ marginTop: "1rem" }}
          >{`终身享${props.backNum}%返现`}</BonusZh>
        )}
        {/* 仅有折扣 */}
        {hasCount && !props.backNum && (
          <BonusZh
            s={"4.2rem"}
            style={{
              marginTop: "1rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              letterSpacing: "0.3rem",
              padding: "0 1rem",
            }}
          >
            <span>会员首单</span>
            <CountSpan len={countLen}>{currentShowCount}</CountSpan>
            <span>折</span>
          </BonusZh>
        )}
      </Wrapper>
    );
  }
};

const Wrapper = styled.div`
  position: relative;
  width: 29.5rem;
  margin: 0 auto;
`;

const RestaurantName = styled(ThemeText)`
  width: 29.5rem;
  margin: 3.4rem auto 0 auto;
  font-weight: 500;
`;

const BannerNumber = styled.span<{
  len: number;
}>`
  position: absolute;
  font-family: Avenir Next Condensed, Avenir Next Condensed Back;
  font-weight: bold;
  line-height: 6.1rem;
  color: #dc0047;
  font-size: ${(props) =>
    props.len === 2 ? "5.6rem" : props.len === 1 ? "7.2rem" : "4.5rem"};
  left: ${(props) =>
    props.len === 2 ? "18.6rem" : props.len === 1 ? "19.5rem" : "18.5rem"};
  top: ${(props) =>
    props.len === 2 ? "0.1rem" : props.len === 1 ? "0.2rem" : "0.1rem"};
    
    
`;

const RewardNum = styled.span<{
  len: number;
}>`
  position: absolute;
  font-family: Avenir Next Condensed, Avenir Next Condensed Back;
  font-weight: bold;
  font-size: ${(props) => (props.len === 2 ? "4.7rem" : "5.2rem")};
  color: #edd6b4;
  line-height:1;
  left: ${(props) => (props.len === 2 ? "12.7rem" : "13.9rem")};
  /*top: ${(props) => (props.len === 2 ? "12rem" : "11.8rem")};*/
  top: ${(props) => (props.len === 2 ? "6.9rem" : "6.7rem")};
`;

const CountSpan = styled.span<{
  len: number;
}>`
  margin: 0 auto;
  font-size: ${(props) => (props.len > 1 ? "inherit" : "5rem")};
  letter-spacing: ${(props) => (props.len > 1 ? 0 : "inherit")};
`;
